import Media from 'components/shared/Media/Media';
import { liveUpdateAttrs } from 'libs/contentful/utils';
import { AspectRatio, MediaAsset } from 'libs/contentful/types';
import { CalloutColumns } from '@/types/constants';
import { CALLOUT_GRID_NUM_ITEMS } from './utils';

/**
 * Props for the CalloutGridCardImage component
 */
interface CalloutGridCardImageProps {
  sys?: { id: string };
  image: MediaAsset;
  columns: CalloutColumns;
  aspectRatio?: AspectRatio;
}

/**
 * Renders an image for a CalloutGrid card
 * Handles responsive sizing and object-fit behavior
 */
const CalloutGridCardImage = ({ sys, image, columns, aspectRatio }: CalloutGridCardImageProps) => {
  const numItems = CALLOUT_GRID_NUM_ITEMS[columns];

  const sizes = `(max-width: 750px) 100vw, (max-width: 1024px) 50vw, ${Math.floor(100 / Math.min(numItems, 3))}vw`;

  return (
    <div className="flex mt-5 justify-center relative rounded-lg" {...liveUpdateAttrs(sys?.id, 'image')}>
      <Media media={image} className="object-cover" sizes={sizes} aspectRatio={aspectRatio} />
    </div>
  );
};

export default CalloutGridCardImage;
